import { render, staticRenderFns } from "./appstore-notification-detail.vue?vue&type=template&id=c109378e&"
import script from "./appstore-notification-detail.vue?vue&type=script&lang=js&"
export * from "./appstore-notification-detail.vue?vue&type=script&lang=js&"
import style0 from "./appstore-notification-detail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports